<script setup>
import { SIcon } from '@n966/soilbox_ui'

defineProps({
  iconName: {
    type: String,
    required: true
  }
})
</script>

<template>
  <div class="button-icon">
    <div class="button-icon-wrapper">
      <s-icon :name="iconName" />
    </div>
  </div>
</template>

<style lang="scss">
.button-icon {
  display: inline-block;
  background: var(--bg);
  border-radius: 4px;

  &-wrapper {
    border-radius: 4px;
    border: 1px solid var(--main-bg);
    display: flex;
    width: 20px;
    height: 20px;
    align-items: center;
    justify-content: center;

    & svg {
      width: 12px;
      height: 12px;
    }
  }
}
</style>
